import liveUpdatesNoticeStyles from './live-updates-notice.styles.css?inline';
import { LitElement, html, nothing, unsafeCSS } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { NetworkStateNotifier } from '../utility/notifications/network-state-notifier';
import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';

import { LIVE_UPDATES_FAILING_NOTICE } from '../utility/notifications/connection-health-words';

/**
 * The on-screen notice for "server fine, live updates failing": live updates have been down for a
 * minute while the server answers and the sign-in holds (D-137, rule 6).
 *
 * Persistent and not closable, because the condition is real until the connection returns, and it
 * clears itself the moment it does. Not blocking: the page still works, it just stops updating
 * itself. It goes NOWHERE but the screen: nothing is logged or sent (the architect: "it goes nowhere
 * other than on the screen").
 */
@customElement('live-updates-notice')
export class LiveUpdatesNotice extends LitElement {
  static styles = unsafeCSS(liveUpdatesNoticeStyles);

  @state() private showing = false;
  private _unsubscribe?: () => void;

  connectedCallback(): void {
    super.connectedCallback();
    const notifier = NetworkStateNotifier.getInstance();
    this._unsubscribe = notifier.onChange(() => {
      this.showing = notifier.health === 'live-updates-failing';
    });
    this.showing = notifier.health === 'live-updates-failing';
  }

  disconnectedCallback(): void {
    this._unsubscribe?.();
    super.disconnectedCallback();
  }

  render() {
    if (!this.showing) return nothing;
    return html`
      <sl-alert variant="warning" open class="notice">
        <sl-icon slot="icon" name="broadcast"></sl-icon>
        ${LIVE_UPDATES_FAILING_NOTICE}
      </sl-alert>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'live-updates-notice': LiveUpdatesNotice;
  }
}
